import React from "react";
import { Truck, ShieldCheck, RotateCcw, Award } from "lucide-react";

const features = [
  {
    icon: <Truck size={20} stroke="#185FA5" />,
    iconBg: "#E6F1FB",
    title: "Free Delivery",
    sub: "Orders over AED 100",
  },
  {
    icon: <ShieldCheck size={20} stroke="#3B6D11" />,
    iconBg: "#EAF3DE",
    title: "Secure Checkout",
    sub: "100% Protected",
  },
  {
    icon: <RotateCcw size={20} stroke="#534AB7" />,
    iconBg: "#EEEDFE",
    title: "No Returns",
    sub: "No refunds",
  },
  {
    icon: <Award size={20} stroke="#854F0B" />,
    iconBg: "#FAEEDA",
    title: "Quality Check",
    sub: "Certified by Experts",
  },
];

const FeatureHighlights: React.FC = () => {
  return (
    <div className="w-full max-w-full overflow-hidden">
      {/* 
        - max-w-full + overflow-x-auto keeps the scroll locked inside this row (prevents full screen horizontal shake)
        - [&::-webkit-scrollbar]:hidden + [-ms-overflow-style:none] + [scrollbar-width:none] hides the ugly scrollbar
      */}
      <div className="flex w-full max-w-full overflow-x-auto px-4 py-1 gap-3 snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-5 md:px-0 md:py-0 md:overflow-visible">
        {features.map((item, i) => (
          <div
            key={i}
            className="flex-shrink-0 w-[240px] sm:w-[260px] md:w-full snap-center flex items-center gap-3 bg-white p-3.5 rounded-xl border border-mediumgray shadow-sm hover:shadow-md transition-all duration-300"
          >
            <div
              style={{ background: item.iconBg }}
              className="w-10 h-10 flex-shrink-0 rounded-lg flex items-center justify-center"
            >
              {item.icon}
            </div>

            <div className="leading-tight overflow-hidden">
              <p className="text-sm font-semibold text-logoHeading truncate">
                {item.title}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {item.sub}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureHighlights;